import StorageCache from '../../utils/StorageCache';
import debounce from './debounce';

const PROXY = 'https://proxy.harryonline.net';

function proxyFetch(link) {
  const headers = {
    'Content-Type': 'application/json',
    'x-proxy-url': link,
  };
  return fetch(PROXY, { headers });
}

async function jsonFetch(link) {
  const response = await proxyFetch(link);
  const json = await response.json();
  return json;
}

const debouncedFetch = debounce(jsonFetch, 5000, {
  leading: true,
  maxWait: 10000,
});

const cache = new StorageCache(
  window.location.hostname === 'localhost' ? sessionStorage : null,
);

async function cachedFetch(link) {
  const cached = cache.get(link);
  if (cached) {
    return cached;
  }
  try {
    const json = await debouncedFetch(link);
    cache.set(link, json);
    return json;
  } catch (e) {
    console.error(e);
    cache.set(link, e.message);
    return null;
  }
}

export default cachedFetch;
